import React from "react";
import { Redirect, Route } from "react-router-dom";
import { Auth } from "redux-server-connection";

export default ({ component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      Auth.isLoggedIn()
        ? React.createElement(component, props)
        : <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location }
            }}
          />}
  />
);



// WEBPACK FOOTER //
// ./src/components/PrivateRoute/index.js